export const slugify = (input: string) => input.toLowerCase().trim().replace(/\s/, '-');